import { render, staticRenderFns } from "./arrow-left-outlined.vue?vue&type=template&id=56cd72c6&scoped=true&"
var script = {}
import style0 from "./arrow-left-outlined.vue?vue&type=style&index=0&id=56cd72c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd72c6",
  null
  
)

export default component.exports